import React, { useEffect, useState } from "react"; // Add useEffect and useState import
import { useParams } from "react-router-dom";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";
import { db } from "../../utils/firebase";
import { doc, getDoc } from "firebase/firestore";
import "./Announcement1.css";

const AnnouncementDetail = () => {
  const { id } = useParams(); // Get the announcement ID from the URL
  const [announcement, setAnnouncement] = useState(null);
  const [clickedImage, setClickedImage] = useState(null); // State for handling clicked image
  
  useEffect(() => { // Using useEffect to fetch announcement data
    const fetchAnnouncement = async () => {
      try {
        const docRef = doc(db, "announcements", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setAnnouncement({ id: docSnap.id, ...docSnap.data() });
        } else {
          console.error("No such announcement!");
        }
      } catch (error) {
        console.error("Error fetching announcement:", error);
      }
    };

    fetchAnnouncement();
  }, [id]);

  const handleImageClick = (image) => {
    setClickedImage(image); // Set the clicked image
  };

  const handleCloseClick = () => {
    setClickedImage(null); // Close the enlarged image
  };

  if (!announcement) {
    return <p>Loading announcement details...</p>;
  }

  return (
    <div>
      <Navbar />
      <div className="announcement-detail-container">
        <div className="announcement-header">
          <h2>{announcement.title}</h2>
          <img
            src={announcement.profile_image || "/placeholder-image.jpg"}
            alt={`${announcement.from}'s profile`}
            className="profile-image154"
          />
          <p>From: {announcement.from}</p>
        </div>
        <div className="announcement-description">
          <p>{announcement.description}</p>
        </div>
        <div className="announcement-images">
          {announcement.images && announcement.images.length > 0 ? (
            announcement.images.map((image, index) => (
              <img
                key={index}
                src={image}
                alt={`Announcement Image ${index}`}
                className="announcement-image"
                onClick={() => handleImageClick(image)} // Add onClick to each image
              />
            ))
          ) : (
            <p>No images available</p>
          )}
        </div>
        {clickedImage && (
          <div className="clicked-image-overlay" onClick={handleCloseClick}>
            <img
              src={clickedImage}
              alt="Enlarged Image"
              className="clicked-image"
            />
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default AnnouncementDetail;
